




























import Input from '@/components/common/Input/Input.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as PropType<{
        minValue?: number;
        avgValue?: number;
        maxValue?: number;
      }>,
    },
    label: { type: String },
    isAvailable: { type: Boolean },
    isArray: { type: Boolean, default: false },
  },
  data: function () {
    return {};
  },
  computed: {
    minAvgMax():
      | undefined
      | {
          min: number;
          avg: number;
          max: number;
        } {
      const analysisResult =
        this.$store.getters.labelAnalysisResult[this.label];

      if (!analysisResult) return undefined;

      // 수치 정보가 있을 경우
      if (
        !this.isArray &&
        (analysisResult.min !== undefined ||
          analysisResult.mean !== undefined ||
          analysisResult.max !== undefined)
      ) {
        return {
          min: analysisResult.min,
          avg: analysisResult.mean,
          max: analysisResult.max,
        };
      }

      // 배열 길이 정보가 있을 경우
      if (
        this.isArray &&
        (analysisResult.min_length !== undefined ||
          analysisResult.mean_length !== undefined ||
          analysisResult.max_length !== undefined)
      ) {
        return {
          min: analysisResult.min_length,
          avg: analysisResult.mean_length,
          max: analysisResult.max_length,
        };
      }

      // 예외처리
      return undefined;
    },
  },
  watch: {
    minAvgMax: {
      handler: function (newVal) {
        // TBD Report Object
        if (!newVal) {
          this.$emit('update:isAvailable', false);
          return;
        }

        this.$emit('update:isAvailable', true);
      },
      deep: true,
    },
  },
  components: { Input },
});
